import { render, staticRenderFns } from "./AcceptanceContactIfPromoter.vue?vue&type=template&id=6159172f&"
import script from "./AcceptanceContactIfPromoter.vue?vue&type=script&lang=ts&"
export * from "./AcceptanceContactIfPromoter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports